import store from '../store'
import isLoading from './is-loading'
import requestRoleContractUpdate from '../request/role-contract-update'
import addError from '../ac/add-error'

export default (userId, contractId, data) => {
  return async (dispatch) => {
    const { auth, workspaceId } = store.getState()
    if (!workspaceId) return

    dispatch(isLoading('update-contract'))

    const result = await requestRoleContractUpdate({
      workspace: workspaceId,
      user: userId,
      contract: contractId,
      contractData: data
    }, auth)

    if (result.error) {
      dispatch(addError(result.error))
    }

    dispatch(isLoading('update-contract', true))
    return result
  }
}
